export default "__VITE_ASSET__mXHBvsyf__"